@if (isMounted()) {
  @let delay = deferEnter() ? animationDuration() : animationEnterDelay();
  <div
    class="mdw-fade"
    [class.no-animation]="!shouldAnimate() && !animateInit()"
    [class.mdw-fade-in]="isEntering()"
    [class.mdw-fade-out]="isLeaving()"
    [style.--mdw-fade-dur]="animationDuration() + 's'"
    [style.--mdw-fade-ease]="animationEasing()"
    [style.--mdw-fade-enter-delay]="delay + 's'"
    [style.--mdw-fade-vertical-offset]="verticalOffset() + 'px'"
    [style.--mdw-fade-leave-start]="ignoreLeave() ? '0' : '1'"
  >
    <ng-content></ng-content>
  </div>
}
